import React from 'react';
import { Link } from 'react-router-dom';
import { HeartHandshake, Instagram, Twitter, Youtube, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gradient-to-r from-pink-50/80 via-white to-blue-50/80 border-t border-purple-100/30 pt-12 pb-8 mt-auto" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-20">
          <div className="col-span-1 md:col-span-2" data-id="element-21">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-22">
              <div className="bg-gradient-to-br from-pink-400 to-blue-400 p-2 rounded-xl" data-id="element-23">
                <HeartHandshake className="h-6 w-6 text-white" data-id="element-24" />
              </div>
              <span className="font-bold text-xl bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent tracking-tight" data-id="element-25">
                CLBK
              </span>
            </Link>
            <p className="text-gray-500 mb-6 max-w-md" data-id="element-26">
              "Ruang aman untuk berbagi cerita, menemukan solusi, dan berkembang
              bersama." Layanan Bimbingan dan Konseling digital yang berpusat
              pada siswa, humanistik, dan suportif. Nadhilah Azfa Khairina
              (2407682)
            </p>
            <div className="flex space-x-4" data-id="element-27">
              <a href="#" className="text-gray-400 hover:text-accent transition-colors" data-id="element-28">
                <Instagram size={20} data-id="element-29" />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary transition-colors" data-id="element-30">
                <Twitter size={20} data-id="element-31" />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-32">
                <Youtube size={20} data-id="element-33" />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-dark transition-colors" data-id="element-34">
                <Mail size={20} data-id="element-35" />
              </a>
            </div>
          </div>

          <div data-id="element-36">
            <h3 className="font-bold text-gray-800 mb-4" data-id="element-37">Tautan Cepat</h3>
            <ul className="space-y-2" data-id="element-38">
              <li data-id="element-39">
                <Link to="/layanan" className="text-gray-500 hover:text-primary transition-colors" data-id="element-40">
                  Konseling Online
                </Link>
              </li>
              <li data-id="element-41">
                <Link to="/artikel" className="text-gray-500 hover:text-primary transition-colors" data-id="element-42">
                  Artikel Edukasi
                </Link>
              </li>
              <li data-id="element-43">
                <Link to="/tes" className="text-gray-500 hover:text-primary transition-colors" data-id="element-44">
                  Tes Minat Bakat
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/tentang" className="text-gray-500 hover:text-primary transition-colors" data-id="element-46">
                  Tentang BK
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-47">
            <h3 className="font-bold text-gray-800 mb-4" data-id="element-48">Bantuan</h3>
            <ul className="space-y-2" data-id="element-49">
              <li data-id="element-50">
                <Link to="/kontak" className="text-gray-500 hover:text-primary transition-colors" data-id="element-51">
                  Hubungi Konselor
                </Link>
              </li>
              <li data-id="element-52">
                <Link to="/kontak" className="text-gray-500 hover:text-accent transition-colors font-medium" data-id="element-53">
                  Layanan Darurat
                </Link>
              </li>
              <li data-id="element-54">
                <Link to="/kontak" className="text-gray-500 hover:text-primary transition-colors" data-id="element-55">
                  FAQ
                </Link>
              </li>
              <li data-id="element-56">
                <Link to="/login" className="text-gray-500 hover:text-primary transition-colors" data-id="element-57">
                  Masuk Akun
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-58">
          <p className="text-gray-400 text-sm text-center md:text-left mb-4 md:mb-0" data-id="element-59">
            © 2026 CLBK (Cerita Layanan Bimbingan Konseling). Hak Cipta
            Dilindungi.
          </p>
          <div className="flex space-x-4 text-sm text-gray-400" data-id="element-60">
            <a href="#" className="hover:text-gray-600" data-id="element-61">
              Kebijakan Privasi
            </a>
            <a href="#" className="hover:text-gray-600" data-id="element-62">
              Syarat & Ketentuan
            </a>
          </div>
        </div>
      </div>
    </footer>;
}